export const MUSIC_NOTE_ASCII = `                                                            
                                                            
                                                            
                             @@@@                           
                            @@@@@@@@@                       
                            @@@@@@@@@@                      
                            @@@@@@@@@@                      
                            @@@@  @@@@                      
                        @@@@@@@@                            
                       @@@@@@@@@                            
                      @@@@@@@@@@                            
                      @@@@@@@@@                             
                        @@@@@@                              
                                                            
                                                            
                                                            `;

export const LOCK_ASCII = `                                                            
                                                            
                                                            
                           @@@@@@                           
                         @@@@  @@@@                         
                         @@@    @@@                         
                         @@@    @@@                         
                       @@@@@@@@@@@@@@                       
                      @@@@        @@@@                      
                      @@@   @@@@   @@@                      
                      @@@    @@    @@@                      
                      @@@@        @@@@                      
                       @@@@@@@@@@@@@@                       
                                                            
                                                            
                                                            `;

export const CHECK_ASCII =  `
                                                            
                                                            
                                                            
                                     @                      
                                   @@@@                     
                                 @@@@@@                     
                                @@@@@                       
                              @@@@@@                        
                     @@@     @@@@@                          
                     @@@@@ @@@@@@                           
                      @@@@@@@@@                             
                        @@@@@@                              
                          @                                 
                                                            
                                                            
                                                            `;
